import styled from 'styled-components'

export const CityPlanViewWrapper = styled.div`
  .button-delete {
    position: absolute;
    right: 50px;
    top: 58px;
  }

  .section-wrapper {
    padding: 40px;
    margin: 0 0 30px 0;

    &.city-details {
      .row:not(:last-child) {
        margin: 0 -15px 30px -15px;
      }

      .link-edit {
        position: absolute;
        right: 40px;
        top: 40px;

        a {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }

    &.kpis {
      .row {
        [class^='col-']:nth-child(2) {
          .ticked {
            position: absolute;
            top: 50%;
            left: 32px;
            width: 14px;
            transform: translateY(-50%);
          }
        }
      }
    }

    &.rosters {
      position: relative;

      .link-add {
        position: absolute;
        right: 40px;
        top: 40px;
      }

      .link-view,
      .link-edit {
        position: relative;
        display: block;
        float: left;
      }

      .link-view {
        svg {
          margin-right: 20px;
        }
      }

      .status {
        width: 87px;
        height: 20px;
        text-align: center;
        border-radius: 10px;
        text-transform: uppercase;
        font-size: ${props => props.theme.fontSizes.statusLabel};
        font-family: ${props => props.theme.fonts.robotoBold};
        line-height: 20px;
        letter-spacing: 0.42px;
        margin: auto;

        &.published {
          background: ${props => props.theme.colors.seeGreen};
          color: ${props => props.theme.colors.white};
        }

        &.draft {
          background: ${props => props.theme.colors.iron};
          color: ${props => props.theme.colors.oxfordBlue};
        }
      }

      td:first-child,
      th:first-child {
        padding-left: 40px;
      }

      td:last-child {
        padding-left: 12px;
      }

      th {
        padding-top: 30px;
        padding-bottom: 23px;
      }
    }

    &:not(:last-child) {
      font-size: ${props => props.theme.fontSizes.commonText};
      color: ${props => props.theme.colors.secondary};
      font-family: ${props => props.theme.fonts.robotoRegular};
    }

    .section-title {
      margin: 0 0 30px 0;
    }

    .section-label {
      margin: 0 0 7px 0;
    }

    .negative-margin {
      margin: 0 -40px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Campaigns/CityPlanView/CityPlanViewWrapper/index.js